import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import ElevatorServiceList from './components/ElevatorServiceList';

const { Cell } = ResponsiveGrid;

const ElevatorService = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="叫梯服務列表"
        // description="公告事項"
        breadcrumbs={[
          {
            name: '叫梯服務',
          },
          {
            name: '叫梯服務列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <ElevatorServiceList />
    </Cell>
  </ResponsiveGrid>
);

export default ElevatorService;
